import { multicolouredTextBright, transition } from '@helpers/animation';
import brand, { darkTheme } from '@helpers/brand';
import { cssVar } from '@helpers/cssVar';
import fonts from '@helpers/fonts';
import { Device, until } from '@helpers/media';
import Link from '@stories/Components/Link/Link';
import styled from 'styled-components';
const Container = styled.nav `
  ${darkTheme};

  display: flex;
  align-items: center;
  background: ${cssVar('bgColor')};
  clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 12px 100%);
  color: ${cssVar('fgColor')};
  height: 44px;
  padding: 0 32px 4px 36px;

  @media ${until(Device.Desktop)} {
    display: none;
  }
`;
const List = styled.ul `
  display: flex;
  margin: 0 -20px;
`;
const Item = styled.li `
  display: block;
  margin: 0 20px;
  transition: color 0.15s ease-out;

  &:focus-within,
  &:hover {
    color: ${brand.orange};
  }

  [data-header-theme='shard-lights'] & {
    &:focus,
    &:hover {
      transition-delay: 0.1s;
      color: transparent;

      > a::before {
        opacity: 1;
      }
    }
  }
`;
const StyledLink = styled(Link) `
  display: flex;
  align-items: center;
  color: currentColor;
  ${fonts.brown.regular};
  font-size: 16px;
  justify-content: flex-start;
  line-height: 22px;
  outline: none;
  text-decoration: none;

  &:focus {
    outline: none;
  }

  [data-header-theme='shard-lights'] & {
    position: relative;

    &::before {
      ${multicolouredTextBright};
      ${transition('opacity')};

      content: attr(data-text);
      opacity: 0;
      position: absolute;
      top: 0;
      left: 0;
    }
  }
`;
export default {
    Container,
    Item,
    Link: StyledLink,
    List,
};
